import Token from './tokens/Token';
import ParenthesesOpenToken from './tokens/ParenthesesOpenToken';
import ParenthesesCloseToken from './tokens/ParenthesesCloseToken';
import SetOpenToken from './tokens/SetOpenToken';
import SetCloseToken from './tokens/SetCloseToken';
import VectorOpenToken from './tokens/VectorOpenToken';
import VectorCloseToken from './tokens/VectorCloseToken';

export default class IndexScanner {

	public static scanForward (tokens: Token[], predicate: (token: Token, index: number, tokens: Token[]) => boolean) {
		return this.scan(tokens, false, predicate);
	}

	public static scanBackward (tokens: Token[], predicate: (token: Token, index: number, tokens: Token[]) => boolean) {
		return this.scan(tokens, true, predicate);
	}

	private static scan (tokens: Token[], reverse: boolean, predicate: (token: Token, index: number, tokens: Token[]) => boolean) {
		const length = tokens.length;
		let depth = 0;

		for (let index = reverse ? length - 1 : 0; reverse ? index >= 0 : index < length; index += reverse ? -1 : 1) {
			const token = tokens[index];

			if (token instanceof ParenthesesOpenToken || token instanceof SetOpenToken || token instanceof VectorOpenToken) {
				depth++;

			} else if (token instanceof ParenthesesCloseToken || token instanceof SetCloseToken || token instanceof VectorCloseToken) {
				depth--;

			} else if (predicate(token, index, tokens) && depth === 0) {
				return index;
			}
		}

		return null;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/IndexScanner.ts